/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import Swal from 'sweetalert2'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { getRequestOptions, postRequestOptions } from "../helpers/Fetchwrapper";
import validationErrorMsg from "../helpers/ValidationErrorMsg";

function UserCreate(props) {
	const [id, setId] = useState('');
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
	const [designation, setDesignation] = useState('');
	const [department, setDepartment] = useState('');
	const [pinId, setPinId] = useState('');
	const [status, setStatus] = useState('active');
	const [departmentOptions, setDepartmentOptions] = useState([]);


	const myRef = useRef();

	useEffect(() => {
		if (id !== props.id || name !== props.email) {
			setId(props.id);
			getUserDetails(props.id);
			window.scrollTo(0, 0);
			myRef.current.focus();
		}
	}, [props.id, props.email]);

	useEffect(() => {
		fetch(process.env.REACT_APP_API_URL + "get_all_department",
			getRequestOptions())
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				setDepartmentOptions(resp);
			})
			.catch((error) => {
				console.log(error, "catch the hoop")
			});
	}, []);


	const getUserDetails = (userId) => {
		fetch(process.env.REACT_APP_API_URL + "user_details/" + userId,
			getRequestOptions())
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				setName(resp.name);
				setEmail(resp.email);
				setPassword(resp.prePassword);
				setConfirmPassword(resp.prePassword);
				setPhoneNumber(resp.phoneNumber);
				setDesignation(resp.designation);
				setDepartment(resp.departmentId);
				setStatus(resp.status);
				setPinId(resp.pinId);
			})
			.catch((error) => {
				console.log(error, "catch the hoop")
			});
	}





	const statusType = [{ label: 'Active', value: 'active' }, { label: 'inactive', value: 'Inactive' }]


	const handleSubmit = (evt) => {
		evt.preventDefault()
		if (id !== '') {
			var text = 'You want to update this User!'
		} else {
			text = 'You want to add this User!'
		}
		Swal.fire({
			title: 'Are you sure?',
			text: text,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No',
			confirmButtonColor: '#ec008c'
		}).then((result) => {
			if (result.value) {
				const formData = {
					id: id,
					name: name,
					email: email,
					password: password,
					password_confirmation: confirmPassword,
					phoneNumber: phoneNumber,
					designation: designation,
					department: department,
					status: status,
					pinId: pinId
				}

				const requestOptions = postRequestOptions(formData);

				if (id !== '') {
					var apiEnd = 'user_update'
				} else {
					apiEnd = 'user_create'
				}

				fetch(process.env.REACT_APP_API_URL + apiEnd, requestOptions)
					.then((resp) => {
						return resp.json()
					})
					.then((resp) => {
						if (resp.success === true) {
							if (id !== '') {
								var successMsg = [`User ${resp.data.email} updated`]
							} else {
								successMsg = [`User ${resp.data.email} added`]
							}

							Swal.fire({
								icon: 'success',
								title: 'Success',
								text: successMsg,
							})
							setId('');
							setName('');
							setEmail('');
							setPassword('');
							setConfirmPassword('');
							setPhoneNumber('');
							setDesignation('');
							setDepartment('');
							setPinId('');
							props.onCreate({ id: resp.data.id, name: resp.data.email })
						} else {

							const errorsMessage = validationErrorMsg(resp.errors).join("<br>");
							Swal.fire({
								icon: 'error',
								title: 'Error',
								html: errorsMessage,
							})
						}
					})
					.catch((error) => {
						console.log(error, 'catch the hoop')
					})
			}
		})
	}

	return (
		<div className='card-body'>
			<div className='ml-12' >
				<form onSubmit={handleSubmit}>
					<div className='form-group row'>
						<label
							htmlFor='name'
							className='col-lg-3 col-form-label'
							style={{ textAlign: 'right' }}
						>
							Name<span className='required text-danger'></span>
						</label>
						<div className='col-lg-5'>
							<input
								type='text'
								name='name'
								id='name'
								ref={myRef}
								value={name}
								onChange={(e) => setName(e.target.value)}
								className='form-control form-control-sm'
							/>
						</div>
					</div>

					<div className='form-group row'>
						<label
							htmlFor='email'
							className='col-lg-3 col-form-label'
							style={{ textAlign: 'right' }}
						>
							Email<span className='required text-danger'></span>
						</label>
						<div className='col-lg-5'>
							<input
								type='email'
								name='email'
								id='email'
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								readOnly={id !== ''}
								className='form-control form-control-sm'
							/>
						</div>
					</div>

					<div className='form-group row'>
						<label
							htmlFor='pinId'
							className='col-lg-3 col-form-label'
							style={{ textAlign: 'right' }}
						>
							Pin ID<span className='required text-danger'></span>
						</label>
						<div className='col-lg-5'>
							<input
								type='pinId'
								name='pinId'
								id='pinId'
								value={pinId}
								onChange={(e) => setPinId(e.target.value)}
								className='form-control form-control-sm'
							/>
						</div>
					</div>

					<div className='form-group row'>
						<label
							htmlFor='password'
							className='col-lg-3 col-form-label'
							style={{ textAlign: 'right' }}
						>
							Password<span className='required text-danger'></span>
						</label>
						<div className='col-lg-5'>
							<input
								type='password'
								name='password'
								id='password'
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								className='form-control form-control-sm'
							/>
						</div>
					</div>

					<div className='form-group row'>
						<label
							htmlFor='confirmPassword'
							className='col-lg-3 col-form-label'
							style={{ textAlign: 'right' }}
						>
							Confirm Password<span className='required text-danger'></span>
						</label>
						<div className='col-lg-5'>
							<input
								type='password'
								name='confirmPassword'
								id='confirmPassword'
								value={confirmPassword}
								onChange={(e) => setConfirmPassword(e.target.value)}
								className='form-control form-control-sm'
							/>
						</div>
					</div>

					<div className='form-group row'>
						<label
							htmlFor='phoneNumber'
							className='col-lg-3 col-form-label'
							style={{ textAlign: 'right' }}
						>
							Phone Number
						</label>
						<div className='col-lg-5'>
							<input
								type='text'
								name='phoneNumber'
								id='phoneNumber'
								value={phoneNumber}
								onChange={(e) => setPhoneNumber(e.target.value)}
								className='form-control form-control-sm'
							/>
						</div>
					</div>

					<div className='form-group row'>
						<label
							htmlFor='designation'
							className='col-lg-3 col-form-label'
							style={{ textAlign: 'right' }}
						>
							Designation<span className='required text-danger'></span>
						</label>
						<div className='col-lg-5'>
							<input
								type='text'
								name='designation'
								id='designation'
								value={designation}
								onChange={(e) => setDesignation(e.target.value)}
								className='form-control form-control-sm'
							/>
						</div>
					</div>

					<div className='form-group row'>
						<label
							htmlFor='department'
							className='col-lg-3 col-form-label'
							style={{ textAlign: 'right' }}
						>
							Department<span className='required text-danger'></span>
						</label>
						<div className='col-lg-5'>
							<select className='form-select form-select-sm' id='department' name='department' value={department} onChange={(e) => setDepartment(e.target.value)} >
								<option value=''>Select Department</option>
								{departmentOptions?.map(function (item, key) {
									return <option key={key} value={item.id}>{item.name}</option>
								})
								}
							</select>
						</div>
					</div>

					<div className="form-group row">
						<label htmlFor="status" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }} >Status<span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<select className="form-select form-select-sm" id="status" name="status" value={status} onChange={(e) => setStatus(e.target.value)} >
								{statusType.map(function (item, id) {
									return <option key={id} value={item.value}>{item.label}</option>
								})
								}
							</select>
						</div>
					</div>


					<div className='row'>
						<div className='col-5'></div>
						<div className='col-6'>
							<input
								type='submit'
								className='btn btn-sm btn-primary mt-2'
								value={id !== '' ? 'Update' : 'Save'}
							/>

						</div>
					</div>
					{/* <pre>
            {JSON.stringify(name, null, 2)}
            {JSON.stringify(status, null, 2)}
          </pre> */}
				</form>
			</div>
			<ToastContainer />
		</div>
	)
}

export default UserCreate
